import TeamOverviewSubPage from "./team-owerview-sub-page";

const SubPage = {
  OverView: TeamOverviewSubPage,
};

export default SubPage;